// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"e09176b6","703":"6c5a7ad4","787":"545aecf5"}[chunkId] + ".chunk.js";
};